import React from 'react'

const StepHeader = ({ iconSrc, label, step, total, active, onClick, position, colors }) => {
  const headerColors = colors || { active: '#9c00b3', inactive: '#8c8f97' }
  const radius =
    position === 'first'
      ? `rounded-t-2xl ${active ? '' : 'rounded-b-none'}`
      : position === 'last'
      ? active
        ? ''
        : 'rounded-b-2xl'
      : position === 'single'
      ? 'rounded-2xl'
      : ''
  return (
    <button
      type="button"
      onClick={onClick}
      className={`w-full flex items-center gap-3 px-3 py-3 border border-gray-400 ${radius}`}
      style={{ backgroundColor: active ? headerColors.active : headerColors.inactive, color: '#fff' }}
    >
      <div className="h-11 w-11 rounded-full bg-white/15 flex items-center justify-center">
        {iconSrc ? <img src={iconSrc} alt="" className="h-7 w-7 object-contain" /> : null}
      </div>
      <div className="flex-1 font-semibold text-left">{label}</div>
      <div className="text-sm opacity-90">
        {step}/{total}
      </div>
      <div className="ml-2">
        <svg width="18" height="10" viewBox="0 0 18 10" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d={active ? 'M3 7l6-6 6 6' : 'M3 3l6 6 6-6'}
            stroke="#fff"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
    </button>
  )
}

export default StepHeader
